import React from 'react'

const HeroSection = () => {
  return (
    <div className=" flex items-center justify-center text-center bg-cover  bg-no-repeat small:h-[313px] h-auto py-4"  style={{ backgroundImage: "url('/contact-banner.png')" }}>

      <div className="flex flex-col justify-between small:px-6 px-4">
      <h1 className="text-[#FFC400] small:text-4xl text-3xl  md:text-[62px] font-bold small:m-5 small:pb-0 p-3 uppercase">Our Blogs</h1>

      <h2 className="text-white  small:text-3xl sm:text-2xl text-lg font-semibold mt-2 small:overflow-hidden small:whitespace-nowrap  small:animate-typing">Latest Insights on Technology & Digital Trends</h2>
       <p  className="text-white   font-medium md:w-[70%] w-full mx-auto text-center mt-2"> Discover expert insights and updates on emerging technologies and digital transformation strategies</p>
      </div>
    </div>
  )
}

export default HeroSection